export const PRODUCT_TRACKED_LIMIT = 599999;
//# sourceMappingURL=limits.js.map